import React, { useEffect, useState } from "react";
import { FaTimes, FaEdit } from "react-icons/fa";

function SelectPhrases(props) {
  const [phrasesList, setPhrasesList] = useState([]);
  const [phrasesSelect, setPhrasesSelect] = useState([]);

  const [startValidate, setStartValidate] = useState(false);

  const [insertMode, setInsertMode] = useState([false]);
  const [namePhrase, setNamePhrase] = useState();
  const [exists, setExists] = useState({ bool: false, value: "" });

  const deletePhrase = (id, label) => {
    var tempLIST = phrasesSelect.filter(function (f) {
      return f.value !== id;
    });
    setPhrasesSelect(
      phrasesSelect.filter(function (f) {
        return f.value !== id;
      })
    );
    var temp = phrasesList;
    temp.push({ value: id, label: label });
    setPhrasesList(temp);

    props.setValue(
      tempLIST.map(function (a) {
        return a.value;
      })
    );
  };

  const sendNewPhrase = (value) => {
    setNamePhrase(" ");
    setStartValidate(true);
    var validatePassed = true;
    if (!namePhrase) validatePassed = false;
    if (validatePassed) {
      var temp = phrasesSelect;
      temp.push({ value: namePhrase, label: namePhrase });
      setPhrasesSelect(temp);
      props.setValue(
        phrasesSelect.map(function (a) {
          return a.value;
        })
      );
      setInsertMode(true);
    }
    if (value !== null) {
      setExists({ bool: false, value: "" });
    }
  };

  useEffect(() => {
    if (props.editMode) {
      var temp = phrasesSelect;

      temp = props.value.map((x) => {
        return { value: x, label: x };
      });

      setPhrasesSelect(temp);
    }
  }, [props.value]);

  return (
    <div className="row mt-3 border px-2 py-4 " style={{ minHeight: "250px" }}>
      <div className="col-9 mb-2">
        <b>Domande</b>
      </div>
      <div className="col-3 mb-2 text-right">
        <button
          disabled={props.disabled ? "" : "disabled"}
          className="btn btn-primary  "
          onClick={() => {
            setInsertMode(!insertMode);
            setNamePhrase(" ");
          }}
        >
          {insertMode ? (
            <>
              <>Nuova Domanda</>
            </>
          ) : (
            <>Annulla</>
          )}
        </button>
      </div>
      {insertMode ? (
        <>
          <div
            className="col-12 border rounded"
            style={{ height: "150px", overflow: "auto", padding: "25px" }}
          >
            {" "}
            <div className="it-list-wrapper">
              <ul className="it-list pt-2">
                {phrasesSelect &&
                  phrasesSelect.map((x, index) => (
                    <li key={index} className="py-2">
                      <div className=" row px-2 py-2">
                        <div className="col-10">
                          {" "}
                          <b>{x.label}</b>{" "}
                          <a
                            href="/#"
                            onClick={() => {
                              setInsertMode(!insertMode);
                              setNamePhrase(x.value);
                              deletePhrase(x.value, x.label);
                            }}
                          >
                            <FaEdit style={{ marginBottom: "4px" }} />
                          </a>
                          <a
                            href="/#"
                            onClick={() => {
                              deletePhrase(x.value, x.label);
                            }}
                          >
                            <FaTimes
                              style={{ marginBottom: "4px", color: "red" }}
                            />
                          </a>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="col-12">
            <div className="row">
              <div className="col-10">
                <div className="row">
                  <div className="col-12">
                    <input
                      id="name"
                      name="name"
                      placeholder="Inserisci la domanda"
                      onChange={(e) => setNamePhrase(e.target.value)}
                      value={namePhrase ? namePhrase : " "}
                      className="form-control"
                      {...(startValidate &&
                        !namePhrase && {
                          infoText: "Il campo non può essere vuoto!",
                        })}
                      {...(startValidate &&
                        !namePhrase && { className: "text-danger" })}
                    />
                  </div>
                </div>
              </div>
              <div className="col-2 text-right ">
                <button
                  onClick={() => {
                    if (exists.bool) {
                      sendNewPhrase(exists.value);
                    } else {
                      sendNewPhrase(null);
                    }
                  }}
                  className="btn btn-primary"
                  disabled={props.disabled ? "" : "disabled"}
                >
                  INSERISCI
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SelectPhrases;
